import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const postNTCoachOfRecordData = (personId, coachObj, state, setState) => {
  if (coachObj) {
    const api = initApi(API_NAMES.PERSON, state, setState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
    const url = `/Person/${personIdForUrl}/PersonCoachOfRecord`;

    return api.executeObject ? api.executeObject(url, 'POST', coachObj) : null;
  }
};

const getNTCoachOfRecordData = (personId, state, setState) => {
  const api = initApi(API_NAMES.PERSON, state, setState);

  const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
  const url = `/Person/${personIdForUrl}/PersonCoachOfRecord`;

  return api.executeArray ? api.executeArray(url, 'GET') : null;
};

const getNTCoachRegistrationData = (personNationalTeamGroupId, state, setState) => {
  const api = initApi(API_NAMES.PERSON, state, setState);

  const personNationalTeamGroupIdForUrl = personNationalTeamGroupId ? encodeURIComponent(personNationalTeamGroupId) : 0;
  const url = `/PersonNationalTeamGroup/${personNationalTeamGroupIdForUrl}/CoachRegistration`;

  return api.executeObject ? api.executeObject(url, 'GET') : null;
};

const putNTCoachRegistrationData = (personNationalTeamGroupId, coachRegistrationObj, state, setState) => {
  if (coachRegistrationObj) {
    const api = initApi(API_NAMES.PERSON, state, setState);

    const personNationalTeamGroupIdForUrl = personNationalTeamGroupId ? encodeURIComponent(personNationalTeamGroupId) : 0;
    const url = `/PersonNationalTeamGroup/${personNationalTeamGroupIdForUrl}/CoachRegistration`;

    return api.executeObject ? api.executeObject(url, 'PUT', coachRegistrationObj) : null;
  }
};

const INITIAL_NATIONAL_TEAM_COACH_OF_RECORD_STATE = {
  ...BASIC_INITIAL_STATE
};

const INITIAL_NT_COACH_REGISTRATION_STATE = {
  ...BASIC_INITIAL_STATE
};

const INITIAL_COACH_OF_RECORD_ADD_STATE = {
  ...BASIC_INITIAL_STATE
};

const INITIAL_COACH_REGISTRATION_STATE = {
  ...BASIC_INITIAL_STATE
};

const NTCoachOfRecordData = {
  INITIAL_NATIONAL_TEAM_COACH_OF_RECORD_STATE,
  INITIAL_NT_COACH_REGISTRATION_STATE,
  INITIAL_COACH_OF_RECORD_ADD_STATE,
  INITIAL_COACH_REGISTRATION_STATE,
  postNTCoachOfRecordData,
  getNTCoachOfRecordData,
  getNTCoachRegistrationData,
  putNTCoachRegistrationData
};

export default NTCoachOfRecordData;